import { ACCESS_CONTROL_MATRIX, AccessControlAction } from '@/constants';
import { selectUserAboutData, useAppSelector } from '@/store';

export const useAccessControl = (action: AccessControlAction): boolean => {
  const userAboutData = useAppSelector(selectUserAboutData);

  if (!userAboutData || !userAboutData.userRole || !ACCESS_CONTROL_MATRIX[userAboutData.userRole]) {
    return false;
  }

  return ACCESS_CONTROL_MATRIX[userAboutData.userRole][action] || false;
};
